// extracted by mini-css-extract-plugin
export default {"main_css_us":"FormLabel_main_css_us__BkF7X","main_css_jp":"FormLabel_main_css_jp__TSQt3"};